import React from 'react'
import PropTypes from 'prop-types'

import clsx from 'clsx'

import { Button as MaterialButton, makeStyles } from '@material-ui/core'

import styles from './styles'

const useStyles = makeStyles(styles)

const Button = ({ noBorderRadius = false, className, children, ...rest }) => {
  const classes = useStyles()

  return (
    <MaterialButton
      className={clsx(className, {
        [classes.noBorderRadius]: noBorderRadius,
      })}
      {...rest}
    >
      {children}
    </MaterialButton>
  )
}

Button.propTypes = {
  noBorderRadius: PropTypes.bool,
}

export default Button
